<template>
  <div class="avatars" :class="size">
    <div class="managers" v-if="this.project !== null">
      <el-badge v-for="(user, key) in taskManagers"
                :key="key"
                @click.stop="gotoUser(user.id)"
                :style="{ 'zIndex' : (200 - key) }"
                :value="user.badge"
                class="avatar">
        <client-code v-if="!user.icon"
                     class="avatar-img"
                     :code="user.code"
                     :seed="user.title"
                     :text-colour="user.textColour"
                     :title="user.title"/>
        <img v-if="user.icon" :src="user.icon_url" class="avatar-img" :title="user.first_name"/>
      </el-badge>
    </div>
    <div class="users">
      <div v-for="(user, key) in taskUsers"
           :key="key"
           @click.stop="gotoUser(user.id)"
           :style="{ 'zIndex' : (100 - key) }"
           class="avatar">
        <client-code v-if="!user.icon"
                     class="avatar-img"
                     :code="user.code"
                     :seed="user.title"
                     :text-colour="user.textColour"
                     :title="user.title"/>
        <img v-if="user.icon" :src="user.icon_url" class="avatar-img" :title="user.first_name"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'project-avatars',
    components: {},
    props: {
      project: { default: null },
      shorten: { default: false },
      task: { default: null },
      size: { default: 'large' }
    },
    data () {
      return {}
    },
    methods: {
      gotoUser (id) {
        this.$router.push({ path: `/users/${id}` })
      }
    },
    computed: {
      // Vuex Mappings
      taskManagers () {
        let managerUsers = []

        if (this.project !== null) {
          // Add Account Manager
          if (this.project.account_manager_id !== null && this.users[this.project.account_manager_id]) {
            managerUsers.push({
              ...this.users[this.project.account_manager_id],
              badge: 'PM'
            })
          }

          // Add Dev Lead
          if (this.project.lead_developer_id !== null && this.users[this.project.lead_developer_id]) {
            managerUsers.push({
              ...this.users[this.project.lead_developer_id],
              badge: 'DEV'
            })
          }

          // Add Design Lead
          if (this.project.lead_designer_id !== null && this.users[this.project.lead_designer_id]) {
            managerUsers.push({
              ...this.users[this.project.lead_designer_id],
              badge: 'DES'
            })
          }
        }

        return managerUsers
      },

      taskUsers () {
        let taskUsers = []
        if (this.project !== null) {
          for (let i = 0; i < this.project.associated_users.length; i++) {
            if (this.users[this.project.associated_users[i]]) {
              let user = this.users[this.project.associated_users[i]]
              // Skip PMs, Devs, and Des Leads
              if (user.id !== this.project.account_manager_id &&
                user.id !== this.project.lead_developer_id &&
                user.id !== this.project.lead_designer_id) {
                taskUsers.push(user)
              }
            }
          }
        } else if (this.task !== null) {
          if (this.task.group_task) {
            for (let i = 0; i < this.task.group_users.length; i++) {
              if (this.users[this.task.group_users[i]]) {
                let user = this.users[this.task.group_users[i]]
                taskUsers.push(user)
              }
            }
          } else {
            let user = this.users[this.task.user_id]
            taskUsers.push(user)
          }
        }

        taskUsers.map(user => {
          // Embed ClientCode data incase the user doesnt have a profile pic
          user.title = user.first_name
          user.code = user.first_name.substr(0, 1).toUpperCase() + user.last_name.substr(0, 1).toUpperCase()
          user.textColour = null
          return user
        })

        taskUsers = taskUsers.sort((a, b) => {
          if (a.first_name < b.first_name) return -1
          if (a.first_name > b.first_name) return 1
          return 0
        })

        if (this.shorten) {
          // We need to stop a heap of images being stacked.
          let maxUsers = 4
          if (taskUsers.length > maxUsers) {
            let keepUsers = taskUsers.slice(0, maxUsers) // Users to be kept in display
            let removedUsers = taskUsers.slice(maxUsers) // Users to be excluded from display

            // Build a list of the kept users
            let userNames = removedUsers.reduce((accumulator, current) => {
              if (accumulator instanceof Object) {
                return accumulator.first_name + ', ' + current.first_name
              }
              return accumulator + ', ' + current.first_name
            })
            keepUsers.push({
              code: '+' + removedUsers.length,
              title: userNames,
              textColour: '#FFF'
            })

            taskUsers = keepUsers
          }
        }

        return taskUsers
      },

      users () {
        return this.$store.state.users.objects
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .avatars {
    text-align: left;

    .managers,
    .users {
      display: inline-block;
      vertical-align: middle;
    }
    .managers {
      margin-right: 5px;
    }

    .avatar {
      display: inline-block;
      vertical-align: middle;
      box-shadow: 1px 1px 2px #606266;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      position: relative;
      margin-left: -10px;
      transition: transform 0.2s;
      cursor: pointer;

      &:hover {
        transform: translateX(8px);
      }

      &:first-child {
        margin-left: 0;
      }

      .avatar-img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        margin: 0;
        display: block;

        &.client-code {
          font-size: 14px;
          line-height: 40px;
        }
      }

      .el-badge__content.is-fixed {
        top: auto;
        bottom: -6px;
        right: -6px;
        transform: none;
        // transform: translate(80%, 0%);
        font-size: 8px;
        height: 16px;
      }
    }

    &.small {
      .avatar {
        width: 30px;
        height: 30px;
      }

      .avatar-img {
        &.client-code {
          font-size: 12px;
          line-height: 30px;
        }
      }
    }
  }

</style>
